module.exports = __webpack_public_path__ + "static/media/screenshot-3.24eda030.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/screenshot-3.png
// module id = 688
// module chunks = 2